export enum CapacityType {
	TIME = 1,
	DURATION = 2,
	RATE = 3,
}
